import { Button } from '@cokitchen/cokitchen-components';
import AddStoreModal from 'components/modals/add-store-modal';
import StoreCard from 'components/store-card';
import useDashboardContext from 'contexts/dashboard.context';
import React, { useState } from 'react';

const GeneralStore = () => {
  const { stores, isStoresLoading } = useDashboardContext();
  const [showModal, setShowModal] = useState(false);
  const openNewStoreModal = () => {
    setShowModal(!showModal);
  };
  return (
    <main className='mx-5'>
      <section className='flex justify-between items-center '>
        <div>
          <h1 className='text-2xl font-bold'>General store dashboard</h1>
          <p className='text-gray-9 text-sm'>Manage and track all your foodcourt stores here</p>
        </div>
        <div>
          <Button
            onClick={openNewStoreModal}
            color='primary'
            variant='block'
            size='small'
            className='px-4'>
            + Add New Store
          </Button>
        </div>
      </section>
      <section className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-10 gap-6 '>
        {isStoresLoading ? (
          <p>Stores loading ...</p>
        ) : stores?.length === 0 ? (
          <p className=''>No stores found </p>
        ) : (
          stores?.map((store) => <StoreCard key={store.name} store={store} />)
        )}
      </section>
      <AddStoreModal show={showModal} onClose={openNewStoreModal} />
    </main>
  );
};

export default GeneralStore;
